import type { Theme } from '@mui/material';

export const styles = {
  insightWheel: (theme: Theme) => ({
    height: '100%',
    borderRadius: '0.25rem',
    backgroundColor: theme.colors.neutral[50],
    padding: '1em',
  }),

  svgCanvas: {
    height: '100%',
    justifyContent: 'center',
  },

  svgContainer: {
    svg: {
      width: '100%',
      height: 'auto',
      maxHeight: '40rem',
    },
  },

  hide: {
    display: 'none',
  },
};
